/**
 * 선물 발송(POINT) 그룹별 멱등키.
 *
 * 🔴 **그룹 + 상품**으로 만든다.
 * - 상품만 쓰면 두 세그먼트가 같은 상품일 때 키가 겹친다. 서버 지문은 센터·상품·결제수단만 비교하므로
 *   두 번째 그룹이 첫 그룹 배치를 `idempotentReplay` 로 받아 **보내지 않았는데 성공으로 보였다.**
 * - 그룹만 쓰면 확인 화면에서 그룹 상품을 바꾸고 다시 보낼 때 서버가 "같은 키, 다른 상품" 409 를 낸다.
 * 같은 모달 안에서 같은 그룹·같은 상품을 다시 보내면 같은 키 → 서버가 기존 배치를 재사용(이중 발송 차단).
 */
export const buildGroupSendIdempotencyKey = (baseKey: string, groupKey: string, productId: string): string =>
    `${baseKey}:${groupKey}:${productId}`;
